import { twMerge } from "tailwind-merge";
import PerfiLogoSvg from "@assets/perfi_logo.svg";
import VSLogoSvg from "@assets/vs_logo.svg";
import { COUNTRY_CODE } from "@/constants";
import { CountryCode } from "@/i18n";

let LogoSVG = VSLogoSvg;

if (COUNTRY_CODE !== CountryCode.LT) {
  LogoSVG = PerfiLogoSvg;
}

interface LogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  className?: string;
  link?: string;
}

export const Logo: React.FC<LogoProps> = (props) => {
  const { className, link, ...rest } = props;

  return (
    <a href={link ?? "/"} className={twMerge("h-6", className)}>
      <img src={LogoSVG} alt="Viena Sąskaita" className="h-6" {...rest} />
    </a>
  );
};
